import React from 'react';
import ReactPaginate from 'react-paginate';
import classNames from 'classnames';
import { Icon } from '@vectord/components';

import styles from './Pagination.module.scss';

function Pagination({
  pageCount,
  onPageChange,
  pageRangeDisplayed = 10,
  className,
  pageClassName,
  breakClassName,
  nextClassName,
  previousClassName,
  activeClassName,
  ...remainingProps
}) {
  return (
    <ReactPaginate
      breakLabel="..."
      nextLabel={<Icon name="arrow-right" />}
      previousLabel={<Icon name="arrow-left" />}
      onPageChange={onPageChange}
      pageRangeDisplayed={pageRangeDisplayed}
      pageCount={pageCount}
      className={classNames(styles.root, className)}
      pageClassName={classNames(styles.page, pageClassName)}
      breakClassName={classNames(styles.break, breakClassName)}
      nextClassName={classNames(styles.next, nextClassName)}
      previousClassName={classNames(styles.previous, previousClassName)}
      activeClassName={classNames(styles.activePage, activeClassName)}
      {...remainingProps}
    />
  );
}

export default Pagination;
